<template>
  <div class="goodsList">
    <div class="headScreening">
      <div class="search">
        <div class="title">{{ $t('newApp.ADList.loai') }}</div>
        <button
          class="shoppingCart"
          :class="addAnimationFlage ? 'animated bounceIn' : ''"
          @click="shoppingCartSwitch"
        >
          <span class="iconfont icon-gouwuche-icon">
            <div v-show="totalNum > 0" :class="totalNum > 99 ? 'maxStyle' : ''">
              <span>
                {{ totalNum | totalNumFilter
                }}
              </span>
            </div>
          </span>
          <span>{{ $t('newApp.ADList.mc') }}</span>
        </button>
        <div class="searchInput">
          <el-select v-model="goodsType" :placeholder="$t('general.ps')" @change="searchBtn">
            <el-option :label="$t('newApp.ADList.rss')" :value="1" />
            <el-option :label="$t('newApp.ADList.Ep')" :value="2" />
          </el-select>
          <input
            type="text"
            @keyup.enter="searchBtn"
            v-model="keyWord"
            :placeholder="$t('newApp.ADList.pewtsf')"
          />
          <button @click="searchBtn">
            <i class="iconfont icon-sousuo-icon" />
          </button>
        </div>
      </div>
      <div class="tabs">
        <div class="label">{{ $t('newApp.ADList.Category') }}</div>
        <div class="tabsBar">
          <div class="options">
            <div class="top">
              <template v-if="lang === 'zh-CN'">
                <span
                  v-for="(item, index) in oneClassifyList.length > 24 ? oneClassifyList.slice(0, 24) : oneClassifyList.length "
                  :key="index"
                  @click="oneClassifyHandle(item)"
                  :class="oneClassifyActive === item.categoryCode ? 'active' : ''"
                >{{ item.categoryName }}</span>
              </template>
              <el-tooltip
                v-else
                v-for="(item, index) in oneClassifyList.length > 24 ? oneClassifyList.slice(0, 24) : oneClassifyList.length "
                :key="index"
                class="item"
                effect="dark"
                :content="item.categoryName"
                placement="top"
              >
                <span
                  @click="oneClassifyHandle(item)"
                  :class="oneClassifyActive === item.categoryCode ? 'active' : ''"
                >{{ item.categoryName }}</span>
              </el-tooltip>
              <span
                class="more"
                v-if="oneClassifyList.length > 24"
                :class="moreOpenFlag ? 'openStyle' : ''"
                @click="moreOpenFlag = !moreOpenFlag"
              >
                <span>{{ $t('newApp.ADList.Am') }}</span>
                <i class="iconfont icon-gengduo-icon" />
              </span>
            </div>
            <div class="bottom" v-if="oneClassifyList.length > 24" v-show="moreOpenFlag">
              <template v-if="lang === 'zh-CN'">
                <span
                  v-for="(item, index) in oneClassifyList.slice(24)"
                  :key="index"
                  @click="oneClassifyHandle(item)"
                  :class="oneClassifyActive === item.categoryCode ? 'active' : ''"
                >{{ item.categoryName }}</span>
              </template>
              <el-tooltip
                v-else
                v-for="(item, index) in oneClassifyList.slice(24)"
                :key="index"
                class="item"
                effect="dark"
                :content="item.categoryName"
                placement="top"
              >
                <span
                  @click="oneClassifyHandle(item)"
                  :class="oneClassifyActive === item.categoryCode ? 'active' : ''"
                >{{ item.categoryName }}</span>
              </el-tooltip>
            </div>
          </div>
          <ul class="monitor" v-show="twoClassifyList.length > 0">
            <li
              v-for="(item, index) in twoClassifyList"
              :key="index"
              @click="twoClassifyHandle(item)"
            >
              <span
                :class="twoClassifyActive === item.categoryCode ? 'active' : ''"
              >{{ item.categoryName }}</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="goodsContent">
      <ul v-show="goodsList.length > 0">
        <li v-for="(item, inde) in goodsList" :key="inde">
          <div class="wrap">
            <div class="image">
              <img v-lazy="item.imgUrl" />
            </div>
            <div class="giftName">{{ item.giftName }}</div>
            <div class="goodsPrice">
              <div>￥{{ item.price }}</div>
              <span>{{ $t('newApp.ADList.Stock') + ":" + (item.stkNum === null ? 0 : item.stkNum )}}</span>
            </div>
            <div class="goodsNum">
              <div class="inputBox">
                <input
                  type="text"
                  maxlength="10"
                  :value="item.addNum"
                  @input="goodsNumChange($event, inde)"
                />
                <div class="btn">
                  <button @click="changeIncrement(inde, 1)">+</button>
                  <button @click="changeIncrement(inde, 0)">-</button>
                </div>
              </div>
              <button @click="addShoopingCart(item)" :disabled="item.stkNum < 1">
                {{ $t('btn.Add') }}
                <i class="iconfont icon-gouwuche-icon" />
              </button>
            </div>
          </div>
        </li>
      </ul>
      <vxe-pager
        v-show="goodsList.length > 0"
        perfect
        :current-page.sync="pageData.pageNum"
        :page-size.sync="pageData.pageSize"
        :total="pageData.total"
        align="center"
        :layouts="['PrevPage', 'JumpNumber', 'NextPage']"
        @page-change="handlePageChange"
      />
      <!--      <vxe-pager-->
      <!--        v-show="goodsList.length > 0"-->
      <!--        background-->
      <!--        :current-page="pageData.pageNum"-->
      <!--        :page-size="pageData.pageSize"-->
      <!--        :page-sizes="[10, 15, 20, 25]"-->
      <!--        :total="pageData.total"-->
      <!--        :layouts="['Total','PrevPage', 'JumpNumber', 'NextPage', 'FullJump', 'Sizes']"-->
      <!--        @page-change="handlePageChange"-->
      <!--      />-->
      <div class="emptyPrompt" v-show="goodsList.length === 0 && !goodsLoadingShow">
        <img :src="nullImageUrl" alt />
        <p>{{ $t('newApp.ADList.isEmpty') }}</p>
      </div>
    </div>
    <div class="goodsLoading" v-show="goodsLoadingShow">
      <div class="wrapper">
        <span />
        <span />
        <span />
        <span />
      </div>
    </div>
  </div>
</template>

<script>
import { newApplicationFormApi } from "../../service";
export default {
  data() {
    return {
      moreOpenFlag: false,
      oneClassifyList: [], // 一级分类列表
      twoClassifyList: [], // 二级分类列表
      oneClassifyActive: "",
      twoClassifyActive: "",
      pageData: {
        pageSize: 16,
        pageNum: 1
      },
      goodsList: [], // 商品列表
      keyWord: "",
      goodsType: 1,
      addAnimationFlage: false,
      nullImageUrl: require("@/assets/images/contentNull.png"),
      goodsNullImage: require("@/assets/images/seatImage.png"),
      goodsLoadingShow: false,
      lang: localStorage.getItem("lang") || "zh-CN"
    };
  },
  props: {
    totalNum: {
      type: Number,
      default: 0
    }
  },
  filters: {
    totalNumFilter(val) {
      return Number(val) < 100 ? val : "99+";
    }
  },
  methods: {
    changeIncrement(index, flag) {
      if (flag) {
        this.$set(
          this.goodsList[index],
          "addNum",
          this.goodsList[index].addNum + 1
        );
        return;
      }
      if (this.goodsList[index].addNum === 1) return;
      this.$set(
        this.goodsList[index],
        "addNum",
        this.goodsList[index].addNum - 1
      );
    },
    async addShoopingCart(item) {
      if (Number(item.addNum) <= 0) {
        this.$message.error(this.$t("newApp.ADList.inoia"));
        return;
      }
      let address = this.$store.state.goodsAddress;
      let params = {
        regionCode: address.provinceCode || "370000",
        cityCode: address.cityCode || "370400",
        districtCode: address.countyCode || "370402",
        address: address.detailedAddress,
        skus: [
          {
            skuCode: item.giftCode,
            skuNum: item.addNum
          }
        ]
      };
      // 判断是否有街道
      if (address.streetCode) params.streetCode = address.streetCode;
      if (address.countryType) {
        params.streetCode = "370402004";
      }
      let judgeSold = await newApplicationFormApi.judgeSold(params);

      // 判断商品是否可售
      if (judgeSold.data[0].statusCode) {
        this.$emit("addShoopingCart", item);
        this.addAnimationFlage = true;
        let timer;
        clearTimeout(timer);
        timer = setTimeout(() => {
          this.addAnimationFlage = false;
        }, 800);
      } else {
        this.$message.error(this.$t("newApp.ADList.tpisafsita"));
      }
    },
    shoppingCartSwitch() {
      this.$emit("shoppingCartSwitch", true);
    },
    goodsNumChange(event, inde) {
      let numVal = event.currentTarget.value
        .replace(/[^\d]/g, "")
        .replace(/^0{1,}/g, "");
      let obj = {
        ...this.goodsList[inde],
        addNum: numVal
      };
      this.$set(this.goodsList, inde, obj);
      // this.goodsList[inde].addNum = numVal;
    },
    searchBtn() {
      this.pageData.pageNum = 1;
      this.oneClassifyActive = "";
      this.twoClassifyActive = "";
      this.getGiftList();
    },
    handlePageChange({ type, currentPage, pageSize, $event }) {
      this.pageData.pageNum = currentPage;
      this.getGiftList();
    },
    oneClassifyHandle(item) {
      this.oneClassifyActive = item.categoryCode;
      this.twoClassifyActive = "";
      this.keyWord = "";
      this.pageData.pageNum = 1;
      this.getGiftList();
      this.twoClassifyList = [];
      if (item.categoryName !== "全部") {
        this.getGiftClassify(item.categoryCode);
      }
    },
    twoClassifyHandle(item) {
      this.twoClassifyActive = item.categoryCode;
      this.keyWord = "";
      this.pageData.pageNum = 1;
      this.getGiftList();
    },
    getGiftList() {
      let addressData = this.$store.state.goodsAddress;
      // let addressCacheData = JSON.parse(sessionStorage.getItem('selectedAddressList'));
      if (!addressData || Object.keys(addressData).length < 1) {
        this.$message.error(this.$t("newApp.ADList.pari"));
        return;
      }
      let params = {
        pageSize: this.pageData.pageSize,
        pageNum: this.pageData.pageNum,
        address: addressData.detailedAddress,
        keyWord: this.keyWord,
        type: this.goodsType,
        provinceCode: addressData.provinceCode || "370000",
        cityCode: addressData.cityCode || "370400",
        countyCode: addressData.countyCode || "370402"
      };
      if (addressData.street && addressData.streetCode)
        params.streetCode = addressData.streetCode;
      if (addressData.countryType) params.country = addressData.country;
      if (this.twoClassifyActive) {
        params.categoryCode = this.twoClassifyActive;
      } else if (this.oneClassifyActive) {
        params.categoryCode = this.oneClassifyActive;
      } else {
        params.categoryCode = "";
      }
      this.goodsLoadingShow = true;
      newApplicationFormApi.getGiftList(params).then(res => {
        if (res.status === "200") {
          this.goodsList = res.data.list.map(item => {
            return {
              addNum: 1,
              amount: 1,
              imgUrl: item.primaryImage
                ? item.primaryImage
                : this.goodsNullImage,
              giftName: item.skuName,
              giftCode: item.skuCode,
              price: item.sellPrice,
              stkNum: item.stock
            };
          });
          this.pageData.total = res.data.total;
        }
        this.goodsLoadingShow = false;
      });
    },
    getGiftClassify(parentCode) {
      newApplicationFormApi.getGiftClassify(parentCode).then(res => {
        if (res.status === "200") {
          if (!parentCode) {
            this.oneClassifyList = [
              {
                categoryName: this.$t("general.All"),
                categoryCode: ""
              },
              ...res.data
            ];
          } else {
            this.twoClassifyList = res.data;
          }
        }
      });
    }
  },
  mounted() {
    this.getGiftClassify();
  }
};
</script>

<style lang="scss" scoped>
@import "@/style/common";

.goodsList {
  width: 100%;
  height: 100%;
  margin: auto 0;
  display: flex;
  flex-direction: column;

  > .headScreening {
    width: 100%;
    background: #ffffff;
    padding: 20px 0 27px;

    > .search {
      width: 1200px;
      margin: 0 auto 20px;

      &:after {
        content: "";
        display: block;
        clear: both;
      }

      > .title {
        float: left;
        line-height: 36px;
        color: #424c57;
        font-size: 18px;
      }

      > .searchInput {
        width: 600px;
        height: 36px;
        display: flex;
        float: right;
        margin-right: 48px;
        position: relative;

        ::v-deep > .el-select {
          width: 103px;
          position: absolute;
          top: 50%;
          left: 3px;
          transform: translateY(-50%);

          > .el-input {
            height: 20px;
            line-height: 20px;

            > input {
              height: 100%;
              border: none;
              border-right: 1px solid #d7dff2;
              border-radius: 0;
              color: #5b646e;
              font-size: 14px;
              line-height: 20px;
            }

            > .el-input__suffix .el-input__icon {
              line-height: 20px;
              color: #5b646e;
            }
          }
        }

        > input {
          height: 100%;
          border: 1px solid #14937b;
          border-right: none;
          outline: 0;
          padding: 0 15px 0 120px;
          font-size: 14px;
          box-sizing: border-box;
          border-top-left-radius: 4px;
          border-bottom-left-radius: 4px;
          flex: 1;

          //&:focus{
          //  border-color: #17A58A;
          //}
          &::placeholder {
            color: #d4d5d5;
          }
        }

        > button {
          width: 60px;
          height: 100%;
          box-sizing: border-box;
          border: 0;
          outline: 0;
          background: #14937b;
          color: #ffffff;
          cursor: pointer;
          display: flex;
          justify-content: center;
          align-items: center;
          border-top-right-radius: 4px;
          border-bottom-right-radius: 4px;

          > i {
            font-size: 14px;
          }
        }
      }

      > .shoppingCart {
        width: 112px;
        height: 36px;
        border: 1px solid #14937b;
        border-radius: 4px;
        float: right;
        outline: none;
        background: #ffffff;
        text-align: center;
        color: #5b646e;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        font-size: 14px;

        &:active {
          background: #14937b;
          border-color: #14937b;
          color: #ffffff;

          > .iconfont {
            color: #ffffff;
          }
        }

        > span {
          margin: 0 4px;
        }

        > .iconfont {
          height: 16px;
          position: relative;
          font-size: 15px;
          color: #14937b;

          > div {
            width: 15px;
            height: 15px;
            position: absolute;
            border-radius: 40px;
            top: -9px;
            right: -8px;
            background: #ed1940;
            color: #ffffff;
            font-size: 12px;
            display: flex;
            justify-content: center;
            align-items: center;

            > span {
              transform: scale(0.8);
            }
          }

          > .maxStyle {
            width: 28px;
            top: -12px;
            right: -20px;
          }
        }
      }
    }

    > .tabs {
      width: 1200px;
      margin: 0 auto;

      &:after {
        clear: both;
        content: "";
        display: block;
      }

      > .label {
        display: inline-block;
        text-align: right;
        color: #303133;
        line-height: 28px;
        float: left;
      }

      > .tabsBar {
        width: 1160px;
        line-height: 28px;
        float: left;

        > .options {
          width: 100%;
          padding-left: 4px;
          position: relative;

          > div {
            position: relative;
            padding-right: 94px;

            > span {
              width: 88px;
              padding: 0 6px;
              line-height: 28px;
              cursor: pointer;
              color: #424c57;
              display: inline-block;
              text-align: left;
              @extend .textOverflow;

              &.active {
                color: #14937b;
                font-weight: bold;
              }
            }

            > .more {
              width: 94px;
              position: absolute;
              top: 0;
              right: 0;

              &.openStyle > i {
                transform: scale(0.5) translateY(-1px) rotate(180deg);
              }

              > span {
                color: #14937b;
              }

              > i {
                color: #14937b;
                display: inline-block;
                transform: scale(0.5) translateY(-1px);
                font-size: 12px;
                transition: 0.3s;
              }
            }
          }
        }

        > .monitor {
          background: #ecf6f5;
          border-radius: 2px;
          padding: 20px 0;

          &:after {
            content: "";
            display: block;
            clear: both;
          }

          > li {
            float: left;
            cursor: pointer;
            color: #747c84;
            padding: 0 16px;

            > .active {
              color: #14937b;
              font-weight: bold;
            }
          }
        }
      }
    }
  }

  > .goodsContent {
    width: 1200px;
    margin: 0 auto;
    //max-height: 500px;
    flex: 1;

    &::-webkit-scrollbar {
      width: 7px;
      height: 10px;
    }

    &::-webkit-scrollbar-thumb {
      border-radius: 5px;
      cursor: pointer;
      background: rgba(144, 147, 153, 0.3);

      &:hover {
        background: rgba(144, 147, 153, 0.5);
      }
    }

    &::-webkit-scrollbar-track {
      border-radius: 10px;
      background: #ffffff;
    }

    > .emptyPrompt {
      text-align: center;

      > img {
        width: 400px;
        margin: 200px 0 14px;
      }

      > p {
        line-height: 20px;
      }
    }

    > ul {
      width: 100%;

      &:after {
        content: "";
        display: block;
        clear: both;
      }

      > li {
        display: inline-block;
        width: 292px;
        padding: 0 12px;
        margin: 30px 4px 0;
        box-sizing: border-box;
        float: left;

        > .wrap {
          background: #ffffff;
          padding-bottom: 15px;

          > .image {
            width: 100%;
            height: 186px;
            border-bottom: 1px solid #f4f6f8;
            overflow: hidden;
            padding: 10px 0;

            > img {
              display: block;
              margin: 0 auto;
              height: 100%;
            }
          }

          > .giftName {
            height: 40px;
            line-height: 22px;
            color: #424c57;
            margin: 20px;
            font-size: 14px;
            word-break: break-all; //在恰当的断字点进行换行
            overflow: hidden; //文字超出的进行隐藏
            text-overflow: ellipsis; //超出的文字用省略号表示
            display: -webkit-box; //将元素设为盒子伸缩模型显示
            -webkit-box-orient: vertical; //伸缩方向设为垂直方向
            -webkit-line-clamp: 2; //设定一共3行，超出的部分隐藏，并用省略号来表示
          }

          > .goodsPrice {
            margin-bottom: 14px;
            padding: 0 20px;
            font-size: 14px;

            &:after {
              display: block;
              content: "";
              clear: both;
            }

            > div {
              color: #f53e48;
              float: left;
            }

            > span {
              color: #989ca0;
              float: right;
            }
          }

          > .goodsNum {
            width: 100%;
            height: 30px;
            padding: 0 20px;
            @extend .clear;

            > .inputBox {
              float: left;
              width: 110px;
              height: 100%;
              border: 1px solid #dcdfe3;
              position: relative;
              border-radius: 4px;

              > input {
                width: 100%;
                height: 100%;
                border: none;
                outline: none;
                text-align: center;
                padding-right: 44px;
                padding-left: 10px;
                color: #354052;
              }

              > .btn {
                position: absolute;
                right: 0;
                top: 0;
                width: 34px;
                height: 100%;
                border-left: 1px solid #dcdfe3;

                > button {
                  width: 100%;
                  height: 50%;
                  line-height: 14px;
                  display: block;
                  padding: 0;
                  border: none;
                  cursor: pointer;
                  color: #5b646e;

                  & + button {
                    border-top: 1px solid #dcdfe3;
                  }
                }
              }
            }

            > button {
              float: right;
              width: 82px;
              height: 100%;
              background: #14937b;
              border: none;
              border-radius: 4px;
              color: #ffffff;
              cursor: pointer;

              &:disabled {
                background: #f5f5f5;
                border: 1px solid #d9d9d9;
                color: #b8b8b8;
                cursor: not-allowed;
              }

              > i {
                font-size: 14px;
                margin-left: 6px;
              }
            }

            //>input{
            //  height: 100%;
            //  border: 1px solid #D7DFF2;
            //  border-right: none;
            //  outline: 0;
            //  padding: 0 5px;
            //  font-size: 14px;
            //  box-sizing: border-box;
            //  flex: 1;
            //  text-align: center;
            //  &:focus{
            //    border-color: #3384FE;
            //  }
            //}
            //>button{
            //  width: 76px;
            //  height: 100%;
            //  box-sizing: border-box;
            //  border: 0;
            //  outline: 0;
            //  background: #3384FE;
            //  color: #ffffff;
            //  cursor: pointer;
            //  &:hover{
            //    background: #4081E2;
            //  }
            //}
            //>button:disabled{
            //  background-color: rgb(192, 196, 204);
            //  cursor: not-allowed;
            //}
          }
        }
      }
    }

    ::v-deep > .vxe-pager {
      background-color: transparent;
      color: #424c58;
      margin: 10px 0;

      .vxe-pager--prev-btn > i:after {
        transform: rotate(180deg);
      }

      .vxe-pager--prev-btn,
      .vxe-pager--next-btn {
        background-color: #f6f7f9;
        border: 1px solid #d7d8da;
        color: #6b7279;

        > i {
          font-style: normal;
          font-size: 12px;

          &:before {
            border: none;
          }

          &:after {
            content: "\e62a";
            display: block;
            font-family: "iconfont" !important;
          }
        }

        &:not(.is--disabled):hover {
          border: 1px solid #17a58a;
        }

        &.is--disabled {
          color: #c6c6c6;
          border: 1px solid #d9d9d9;
        }
      }

      .vxe-pager--btn-wrapper {
        > .vxe-pager--num-btn {
          background-color: #f6f7f9;
          border: 1px solid #d7d8da;
        }

        > .vxe-pager--num-btn:not(.is--disabled):hover {
          border: 1px solid #17a58a;
          color: #424c58;
        }

        > .is--active {
          background-color: #14937b;
          color: #ffffff !important;
          border: 1px solid #14937b;
        }

        & > .vxe-pager--jump-prev,
        & > .vxe-pager--jump-next {
          color: #c0c0c0;
          background: transparent;
          line-height: 1.8em;

          &:not(.is--disabled):hover {
            color: #17a58a;
          }
        }
      }

      .vxe-pager--jump {
        > input:focus {
          border: 1px solid #14937b;
        }
      }
    }
  }

  > .goodsLoading {
    width: 40px;
    height: 40px;
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    > .wrapper {
      width: 100%;
      height: 100%;
      position: relative;

      > span {
        display: block;
        bottom: 0;
        width: 20px;
        height: 20px;
        background: #9b59b6;
        position: absolute;
      }

      & > span:nth-child(1) {
        animation: preloader1 1.5s infinite ease-in-out;
      }

      & > span:nth-child(2) {
        left: 20px;
        animation: preloader2 1.5s infinite ease-in-out;
      }

      & > span:nth-child(3) {
        top: 0;
        animation: preloader3 1.5s infinite ease-in-out;
      }

      & > span:nth-child(4) {
        top: 0;
        left: 20px;
        animation: preloader4 1.5s infinite ease-in-out;
      }
    }
  }
}

@keyframes preloader1 {
  0% {
    transform: translateX(0px) translateY(0px) rotate(0deg);
    border-radius: 0px;
  }

  50% {
    transform: translateX(-20px) translateY(-10px) rotate(-180deg);
    border-radius: 20px;
    background: #3498db;
  }

  80% {
    transform: translateX(0px) translateY(0px) rotate(-360deg);
    border-radius: 0px;
  }

  100% {
    transform: translateX(0px) translateY(0px) rotate(-360deg);
    border-radius: 0px;
  }
}

@keyframes preloader2 {
  0% {
    transform: translateX(0px) translateY(0px) rotate(0deg);
    border-radius: 0px;
  }

  50% {
    transform: translateX(20px) translateY(-10px) rotate(180deg);
    border-radius: 20px;
    background: #f1c40f;
  }

  80% {
    transform: translateX(0px) translateY(0px) rotate(360deg);
    border-radius: 0px;
  }

  100% {
    transform: translateX(0px) translateY(0px) rotate(360deg);
    border-radius: 0px;
  }
}

@keyframes preloader3 {
  0% {
    transform: translateX(0px) translateY(0px) rotate(0deg);
    border-radius: 0px;
  }

  50% {
    transform: translateX(-20px) translateY(10px) rotate(-180deg);
    border-radius: 20px;
    background: #2ecc71;
  }

  80% {
    transform: translateX(0px) translateY(0px) rotate(-360deg);
    border-radius: 0px;
  }

  100% {
    transform: translateX(0px) translateY(0px) rotate(-360deg);
    border-radius: 0px;
  }
}

@keyframes preloader4 {
  0% {
    transform: translateX(0px) translateY(0px) rotate(0deg);
    border-radius: 0px;
  }

  50% {
    transform: translateX(20px) translateY(10px) rotate(180deg);
    border-radius: 20px;
    background: #e74c3c;
  }

  80% {
    transform: translateX(0px) translateY(0px) rotate(360deg);
    border-radius: 0px;
  }

  100% {
    -transform: translateX(0px) translateY(0px) rotate(360deg);
    border-radius: 0px;
  }
}
</style>
